import { SkeletonLoader } from '@design';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useDocumentSections } from '@terminal/react-query-hooks/documents/useDocumentsEntity';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { CitationsAccordionWidget } from '@terminal/widgets/citations-accordion-widget/CitationsAccordionWidget';
import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './GeoSourceEvidenceSection.module.scss';

interface GeoSourceEvidenceSectionProps {
  evidence?: string[] | null;
  sourceEvidence?: string | null;
}

export const GeoSourceEvidenceSection = ({
  evidence,
  sourceEvidence,
}: GeoSourceEvidenceSectionProps) => {
  const { t } = useTranslation(['widget']);
  const { data, isFetching } = useDocumentSections(evidence ?? []);

  if (!sourceEvidence && !data.length && !isFetching) {
    return null;
  }

  return (
    <div className={styles.sectionRow}>
      <div className={styles.titleBase}>
        {t(
          'widget:assetOverview.knowledgeGraph.themeExposure.tabs.themeExposure.sourceEvidence'
        )}
      </div>
      <ErrorBoundaryWrapper>
        <>
          {isFetching ? (
            <SkeletonLoader
              data-testid="loading-skeleton"
              areas={[
                {
                  styles: {
                    width: '100%',
                    height: '180px',
                    borderRadius: '8px',
                  },
                },
              ]}
            />
          ) : (
            <>
              {sourceEvidence && (
                <div className={styles.bodySmall} data-testid="evidence">
                  {sourceEvidence}
                </div>
              )}
              <CitationsAccordionWidget
                citations={data}
                trackingMetadata={{
                  source: POSTHOG_TRACKING_SOURCES.COMPANY_TO_GEO_DRAWER,
                }}
              />
            </>
          )}
        </>
      </ErrorBoundaryWrapper>
    </div>
  );
};
